<template lang="pug">
  .step.edit-modes
    .step-description {{$t('EDIT_MODE_DESCRIPTION')}}
    .step-image(:style="{backgroundImage: 'url(' + this.image + ')'}")
</template>
<script>
export default {
  name: 'EditModes',
  data() {
    return {
      image: require('@/assets/images/first-steps/step-1-image.svg')
    }
  }
}
</script>
